import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';

// a Sentry instrumented browser router (using V6 variant for react-router v6.x)
const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

export default sentryCreateBrowserRouter;
